<template>
    <div>
        <header id="page-header">
            <div class="wrapper">

                <div class="logo" :title="$store.getters.scope.name">
                    <img :src="$store.getters.scope.picture.url" v-if="$store.getters.scope && $store.getters.scope.picture">
                    <span v-bind:style="{background:$store.getters.scope.color}" v-if="$store.getters.scope && !$store.getters.scope.picture">{{ $store.getters.scope.name.substr(0,1) }}</span>
                </div>

                <div class="spacer"></div>

                <div v-if="$store.getters.user.scopes.length > 1">
                    <div class="console-api"><span><i class="icon icon-icon_earth"></i> {{ $store.getters.debugApiUrl }}</span><span><i class="icon icon-icon_home"></i> {{ $store.getters.path }}</span></div>
                    <div><router-link to="/switch"><i class="icon icon-icon_layers"></i></router-link></div>
                    <!--
                    <div class="switch-workspace" v-if="$store.getters.user">
                        <i class="icon icon-icon_layers"></i>
                        <span>{{ $store.getters.scope.name }}</span>
                        <select v-on:change="onChange" v-model="client">
                            <option v-for="item in $store.getters.user.scopes" :value="item.token">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    -->
                </div>

                <div class="account">
                    <div class="picture">
                        <figure>
                            <i v-if="!$store.getters.user.person.picture" class="icon icon-icon_person"></i>
                            <img v-if="$store.getters.user.person.picture" :src="$store.getters.user.person.picture.url+'/fit/100x100'"/>
                        </figure>
                    </div>
                    <div class="information">
                        <span>{{ $store.getters.user.person.firstname }} {{ $store.getters.user.person.lastname }}</span>
                        <span>{{ $store.getters.user.person.email }}</span>
                    </div>
                </div>

            </div>
        </header>
        <nav id="page-navigation">
            <div class="wrapper">
                <ul>
                    <li v-if="$store.state.modules.indexOf('dashboard')>=0"><router-link to="/dashboard"><i class="icon icon-icon_layers"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('crm')>=0"><router-link to="/crm"><i class="icon icon-icon_users"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('checkin')>=0"><router-link to="/checkin"><i class="icon icon-icon_home"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('config')>=0"><router-link to="/config"><i class="icon icon-icon_cog"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('logout')>=0"><a href="#" v-on:click="logout"><i class="icon icon-icon_logout"></i></a></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'headerVue',
        data () {
            return {
                client: this.$store.getters.scope,
            }
        },
        methods: {
            logout: function(event) {
                this.$store.dispatch("logout").then(() => {
                    this.$router.push("/login")
                });
            },
            onChange: function(event){
                this.$store.dispatch("switchScope", event.srcElement.value).then(() => {
                    //this.$router.push("/dashboard")
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Header.vue